// Shared by the SIM list, the SIM modal (Change #100665) and the company
// "SIM Connectivity" screen (Change #100666).

// emnify SIM status id -> reactstrap badge colour
export const statusColor = (statusId) => {
  switch (Number(statusId)) {
    case 1:
      return "success"; // Activated
    case 2:
      return "warning"; // Suspended
    case 0:
      return "secondary"; // Issued
    case 3:
      return "danger"; // Deleted
    default:
      return "light";
  }
};

// Stored BIC (#312FBUD2QO3QNJI) shown the portal way (#312-FBUD-2QO3-QNJI)
export const displayBic = (raw) => (raw || "").replace(/(.{4})(?=.)/g, "$1-");

// Change #100663 - eSIM or physical, from what the emnify sync stores
// (model.formfactor.name, model.description, profile_type.description).
// Returns { kind: "esim" | "physical" | null, detail }. null = not synced yet.
//
// The FORM FACTOR decides. emnify's real data: model "Commercial eSIM 1/2
// size, Triple-cut", form factor "Triple-Cut 1/2 size", profile "M2M eUICC
// Profile" - a plastic card you push into a slot that happens to carry an
// eUICC chip. That is a physical SIM, even though "eSIM" is in the model name.
const PHYSICAL_FORM_FACTOR =
  /cut|plug|mini|micro|nano|[1-4]\s*ff\b|mff|chip|card|solder/i;
const ESIM_FORM_FACTOR = /e-?sim|virtual|digital|download|consumer/i;
export const simType = (item) => {
  const formFactor = (item?.SimFormFactor || "").trim();
  const model = (item?.SimModelDescription || "").trim();
  const profile = (item?.SimProfileType || "").trim();
  const eUicc = /euicc/i.test(profile) ? "eUICC" : "";
  const detail = [formFactor || model, eUicc].filter(Boolean).join(" · ");
  if (formFactor && ESIM_FORM_FACTOR.test(formFactor))
    return { kind: "esim", detail };
  if (formFactor && PHYSICAL_FORM_FACTOR.test(formFactor))
    return { kind: "physical", detail };
  // No recognisable form factor: fall back to the model name.
  if (ESIM_FORM_FACTOR.test(model) && !PHYSICAL_FORM_FACTOR.test(model)) {
    return { kind: "esim", detail };
  }
  if (formFactor || model) return { kind: "physical", detail };
  return { kind: null, detail: "" };
};

// Change #100667 - emnify endpoint connectivity -> badge colour + plain words.
export const connectivityBadge = (status) => {
  switch (String(status || "").toUpperCase()) {
    case "ONLINE":
      return {
        color: "success",
        text: "Online",
        hint: "Has an active data connection",
      };
    case "ATTACHED":
      return {
        color: "info",
        text: "Attached",
        hint: "On the network, no data session open right now",
      };
    case "OFFLINE":
      return {
        color: "secondary",
        text: "Offline",
        hint: "Not attached, or the network reported no activity for 1-2 days",
      };
    case "BLOCKED":
      return {
        color: "danger",
        text: "Blocked",
        hint: "Over its traffic limit",
      };
    default:
      return { color: "light", text: "Unknown", hint: "" };
  }
};

// emnify volumes are MB.
export const formatMb = (mb) => {
  const n = Number(mb) || 0;
  if (n >= 1024) return `${(n / 1024).toFixed(2)} GB`;
  if (n >= 1) return `${n.toFixed(1)} MB`;
  return `${Math.round(n * 1024)} KB`;
};
